import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { catchError, map } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';

@Injectable({
    providedIn: 'root'
})
export class SmsService {

    constructor(private http: HttpClient, private logger: LoggerService) { }

    sendVerificationCode(mobileNumber: string) {
        return this.http.get<any>(window.location + 'umbraco/api/smsverify/get/', {
            params: {
                mobilePhoneNumber: mobileNumber
            }
        }).pipe(
            map((response: HttpResponse<any>) => response),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    this.logger.error('sendVerificationCode 404 not found', error);
                    // return null;
                } else {
                    console.log(error);
                    this.logger.error('sendVerificationCode error', error.data);
                    // return null;
                }
                return of(error);
            })
        );
    }

    verifySmsCode(mobileNumber: string, smsVerifyCode: string) {
        console.log(mobileNumber);
        console.log(smsVerifyCode);
        const model = {
            mobilePhoneNumber: mobileNumber,
            verificationCode: smsVerifyCode
        };

        return this.http.post(window.location + 'umbraco/api/smsverify/post/', model, { observe: 'response' }).pipe(
            map((response: HttpResponse<any>) => response),
            catchError((error: any) => {
                if (error.status === 404) { // not found
                    this.logger.error('smsVerify 404 not found', error);
                    // return null;
                } else {
                    this.logger.error('smsVerify error', error.data);
                    // return null;
                }
                return of(error);
            })
        );
    }
}
